// ResumeCard.js
import React, { useEffect } from 'react';
import { Card, Button, Row, Col, Badge } from 'react-bootstrap';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import Modal from 'react-bootstrap/Modal';
import { isEmpty } from 'utils/utils';
import { saveToLocalStorage } from 'utils/LocalStorageUtils';
import { apiCall } from 'utils/httpClient';
import apiEndPoint from 'utils/apiEndPoint';
import { loadFromLocalStorage } from 'utils/LocalStorageUtils';

const ResumeCard = ({ item, title, status, name, domainName, thumbnail, onEdit, onPublish, onSwitch, publishable, getOrderList, handleViewClick, handleOpenSwitchTemplate, handleSelectDomain }) => {
  const imageUrl = "https://img.freepik.com/free-vector/travel-landing-page-with-photo_23-2148368113.jpg?t=st=1729150768~exp=1729154368~hmac=e5ffbd02b7225ae79ad477312b7472cd4992047399d0a7d871adc8f6bf0b826c&w=1380"
  const [show, setShow] = useState(false);
  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])

  const navigate = useNavigate(); // Create navigate function

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleEditWebsite = () => {
    saveToLocalStorage("selectOrderDetail", item);
    saveToLocalStorage("selectTemplate", null);
    navigate('/templateform'); // Navigate to the desired route
  };

  const onDeleteOreder = async () => {

    // let header = { token: authData?.token }
    let params = { order_id: item._id }
    var { data } = await apiCall("post", apiEndPoint.ORDERDELETE, params);
    if (data.status === 200) {
      getOrderList()
    }
  };


  return (
    <Card className="m-2">
      {status === 'draft' && <Button size='sm' style={{ width: 'fit-content', position: 'absolute', right: '10px', top: '10px' }} variant="outline-primary" onClick={onDeleteOreder}>x</Button>}
      <Row noGutters style={{ alignItems: 'center' }}>
        <Col lg={2} md={2}>
          <Card.Img style={{ padding: '8px', borderRadius: 15, width: 180 }} src={!isEmpty(thumbnail) ? thumbnail : imageUrl} alt="Resume Image" />
        </Col>
        <Col lg={6} md={4}>
          <Card.Body>
            <Card.Title>{title}</Card.Title>
            {domainName && <Card.Subtitle className="mb-2 text-muted">{languageData?.domain}: {domainName}</Card.Subtitle>}
            <Card.Text>
              {status === 'draft' ?
                <Badge bg="danger"><strong>{languageData?.draft}</strong></Badge>
                : status === "under_review" ?
                  <Badge bg="info"><strong>{languageData?.underReview}</strong></Badge>
                  : status === "published" ?
                    <Badge bg="success"><strong>{languageData?.published}</strong></Badge>
                    : status === "inactive" ?
                      <Badge bg="danger"><strong>{languageData?.inactive}</strong></Badge>
                      : ''
              }
            </Card.Text>
          </Card.Body>
        </Col>
        <Col lg={4} md={6}>
          <Button
            style={{ margin: '5px', borderRadius: 15, padding: '5px 20px', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
            size='sm'
            className="mr-2"
            onClick={handleEditWebsite} // Use handleEditWebsite for onClick
          >
            {languageData?.editWebsite}
          </Button>
          {status === 'draft' && publishable &&
            <Button style={{ margin: '5px', borderRadius: 15, padding: '5px 20px', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='sm' className="mr-2" onClick={handleShow}>{languageData?.publish}</Button>
          }
          {status === 'draft' &&
            <br />
          }
          <Button style={{ margin: '5px', borderRadius: 15, padding: '5px 20px', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='sm' onClick={() => handleViewClick(item)} className="mr-2" >{languageData?.preview}</Button>
          {status === 'draft' &&
            <Button style={{ margin: '5px', borderRadius: 15, padding: '5px 20px', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='sm' onClick={() => handleOpenSwitchTemplate(item)} className="mr-2">{languageData?.switchTemplate}</Button>
          }
        </Col>
      </Row>

      <Modal centered show={show} onHide={handleClose} style={{ fontFamily: 'quicksand' }}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>{languageData?.doYouWantToPublishThisTemplate}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {languageData?.theSelectedThemeWillBeApplied} <a href="">{languageData?.switchTemplate}.</a> */}
          <br /> <br />
          <p className='mb-0'>Current Theme: {title}</p>
          <p className='mb-0'>Current Folder: {domainName}</p>
          {/* <p>New Theme: Resume 20</p> */}
        </Modal.Body>
        <Modal.Footer>
          <Button style={{ margin: '5px', borderRadius: 15, width: 'inherit', fontSize: 12, fontWeight: 500 }} size='md' variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button style={{ margin: '5px', borderRadius: 15, width: 'inherit', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='md' onClick={() => { handleClose(); handleSelectDomain(item) }}>
            {languageData?.publish}
          </Button>
        </Modal.Footer>
      </Modal>


    </Card>
  );
};

export default ResumeCard;